import * as React from "react";

import {
  GroupingState,
  IntegratedGrouping,
  IntegratedSorting,
  SortingState
} from "@devexpress/dx-react-grid";
import {
  DragDropProvider,
  Grid,
  GroupingPanel,
  Table,
  TableGroupRow,
  TableHeaderRow,
  Toolbar
} from "@devexpress/dx-react-grid-material-ui";
import SamplingCell from "./SamplingCell";

export default class SamplingsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { rows, columns } = this.state;
    const tableColumnExtensions = [
      //company name
      { columnName: "outlet" },
      { columnName: "sampling_Id" },
      { columnName: "kampagne" },
      { columnName: "type" },
      { columnName: "samples" },
      { columnName: "date" },
      { columnName: "bartenders" },
      { columnName: "duration" }
    ];
    if (this.props.myData.length > 0) {
      return (
        <Grid rows={this.props.myData} columns={this.props.dataColumn}>
          <SortingState
            defaultSorting={[{ columnName: "region", direction: "desc" }]}
          />
          <GroupingState
            grouping={this.props.grouping}
            defaultExpandedGroups={this.props.defaultExpandedGroups}
          />
          <IntegratedGrouping />
          <IntegratedSorting />

          <DragDropProvider />
          <Table
            columnExtensions={tableColumnExtensions}
            cellComponent={SamplingCell}
          />
          <TableHeaderRow showSortingControls={true} />
          <TableGroupRow />
          <Toolbar />
          <GroupingPanel showSortingControls={true} />
        </Grid>
      );
    } else {
      return <div>Loading</div>;
    }
  }
}
